import { Component, Input } from '@angular/core';
import { ProductDetails } from '../modal-pricing-details/modal-pricing-details.component';
import { ModalViewSubscriptionPlanService } from 'src/app/services/modal-view-subscription-plan.service';
import { ServicesService } from 'src/app/services/services.service';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-modal-subscription-plan',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './modal-subscription-plan.component.html',
  styleUrl: './modal-subscription-plan.component.scss'
})
export class ModalSubscriptionPlanComponent {
  @Input() productInput: ProductDetails
  isLoading: boolean = false
  user: User

  constructor(
    public modalViewSubscriptionPlanService: ModalViewSubscriptionPlanService,
    private servicesService: ServicesService,
    private userService: UserService
  ) {
    this.user = userService.user
  }

  subscribeToService(serviceName: string): void {
    this.isLoading = true
    this.servicesService.subscribe(serviceName).subscribe({
      next: () => {
        console.log("Subscribed to service: ", serviceName)
        this.modalViewSubscriptionPlanService.hideModal()
        this.isLoading = false
      },
      error: (err) => {
        console.error(`Error subscribing to ${serviceName}`, err)
        this.isLoading = false
      }
    })
  }
}
